import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
    className : PropTypes.string.isRequired,
    children : PropTypes.array.isRequired
}

const Li = styled.li``

const OlComponent = ({
    className,
    children
}) => {
    return (
        <ol className={className}>
            {children && children.map((child, i) => {
                return <Li key={`ordered-item-${i}`}>{child}</Li>
            })
            }
        </ol>
    )
} 

OlComponent.propTypes = propTypes;

const Ol = styled(OlComponent)`
    * :not(a){   
        font-family: ${(props) => props.theme.typography.body.fontFamily};
        font-size: ${(props) =>
        props.size || props.theme.typography.body.fontSize}rem;
        color: ${(props) => props.theme.palette.text['200']}
    }`

export default Ol;